import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Breadcrumbs, Box, makeStyles} from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {Link} from 'gatsby-theme-material-ui';
import {ScrollTop} from 'components/atoms';
import legacyTutorialToNav from 'helpers/legacyTutorialToNav';
import {tutorialPageUrl, tutorialsRootUrl, tutorialUrl} from 'helpers/links';
import {usePageContext} from 'data/page-context';
import {Topbar, Navbar} from './components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('md')]: {
      paddingLeft: 256,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 128,
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 0,
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
  },
}));

const createBreadcrumbs = ({tutorial, page, track}) => {
  const legacy = true;
  const breadcrumbs = [];
  if (track) {
    breadcrumbs.push(
      <Link color="inherit" to={tutorialsRootUrl({legacy, track})}>
        {track.title}
      </Link>
    );
  } else {
    breadcrumbs.push(
      <Link color="inherit" to="/tutorials/">
        Tutorials
      </Link>
    );
  }

  if (tutorial) {
    const lastCrumb = !page;
    breadcrumbs.push(
      <Link
        color={lastCrumb ? 'textPrimary' : 'inherit'}
        aria-current={lastCrumb && 'page'}
        to={tutorialUrl({tutorial, legacy, track})}
      >
        {tutorial.title}
      </Link>
    );
  }

  if (page) {
    breadcrumbs.push(
      <Link color="textPrimary" to={tutorialPageUrl({tutorial, page, legacy, track})}>
        {page.title}
      </Link>
    );
  }

  return (
    <Box pl={2}>
      <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
        {breadcrumbs}
      </Breadcrumbs>
    </Box>
  );
};

const LegacyCourseLayout = ({children, themeToggler, themeMode}) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const {tutorial, page, track} = usePageContext() || {};

  const navBarData = legacyTutorialToNav({tutorial, page, track});
  const breadcrumbs = createBreadcrumbs({tutorial, page, track});

  return (
    <div className={classes.root}>
      <Topbar
        themeMode={themeMode}
        themeToggler={themeToggler}
        onMobileNavOpen={() => setMobileNavOpen(true)}
        breadcrumbs={breadcrumbs}
      />
      <Navbar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
        navBarData={navBarData}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
      <ScrollTop />
    </div>
  );
};

LegacyCourseLayout.propTypes = {
  children: PropTypes.node,
  themeToggler: PropTypes.func.isRequired,
  themeMode: PropTypes.string.isRequired,
};

export default LegacyCourseLayout;
